import { Box, Stack, Typography } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';

export const SelectArrangeBy: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Stack height="100%" alignItems="center" justifyContent="center" gap={2.5}>
      <Box maxWidth={330}>
        <Typography
          variant="h1"
          textAlign="center"
          sx={{
            fontStyle: 'normal',
          }}
        >
          <FormattedMessage id="selectArrangeByFromChart" />
        </Typography>
      </Box>

      <Box minWidth={200}>{children}</Box>
    </Stack>
  );
};
